export const passwordValidator = (password: string) => {
  const atLeastOneUppercase = /[A-Z]/g;
  const atLeastOneLowercase = /[a-z]/g;
  const atLeastOneNumeric = /[0-9]/g;
  const atLeastOneSpecialChar = /[#?!@$%^&*-]/g;
  const eightCharsOrMore = /.{8,}/g;

  const passwordTracker = {
    uppercase: {
      message: "capital letters from A to Z",
      validator: password?.match(atLeastOneUppercase),
    },
    lowercase: {
      validator: password?.match(atLeastOneLowercase),
      message: "small letters from a to z",
    },
    number: {
      validator: password?.match(atLeastOneNumeric),
      message: "numbers from 0 to 9",
    },
    specialChar: {
      validator: password?.match(atLeastOneSpecialChar),
      message: "#?!@$%^&*-",
    },
    eightCharsOrGreater: {
      validator: password?.match(eightCharsOrMore),
      message: "eight characters or more",
    },
  };

  return passwordTracker;
};
